import React from 'react'
import styles from './Project.module.css'
import orderBy from 'lodash/orderBy'
import {Header} from './Header'
import add from '../images/add.svg'
import BackButton from './BackButton'
import axios from 'axios'
import Spinner from './Spinner'
// @ts-expect-error
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import { DeleteAppConfigButton } from './DeleteAppConfigButton'
import { deleteAppConfig } from '../api/delete-app-config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen, faDatabase, faXmark } from '@fortawesome/free-solid-svg-icons';
import { RouteComponentProps, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from '../store'
import { getAuthHeaders, useWistorAuth, WistorAuth } from '../api/auth'

export default function Project(props: RouteComponentProps) {
  const store = useSelector(s => ({project: s.project}))
  const dispatch = useDispatch()
  const auth = useWistorAuth()
  const history = useHistory()

  React.useEffect(() => {
    let projectPath = (props.match.params as any).projectPath as string
    let project = store.project
    if (project.path === projectPath && !project.loading) return

    if (auth.status !== 'authorized') return history.push('/login', `projects/${projectPath}`)

    axios.get('/api/projects/' + projectPath,{
      headers: getAuthHeaders(),
    }).then(({ data }) => dispatch({type: 'FETCH_PROJECT_SUCCESS', data}))
  }, [])

  const newClicked = () => {
    let path = makeID()
    history.push(`/projects/${store.project.path}/${path}/edit`)
  }

  const deleteApp = async (id: string) => deleteAppConfig(id, dispatch)

  let project = store.project
  if (project.loading) return <Spinner />

  let viewers = project.viewers
  viewers = orderBy(viewers, ['title'], ['asc'])

  const renderedViewers = !viewers.length
    ? (
      <div className={styles.noViewerMessage}>
        No apps found in this project...
      </div>
    ) : (
      <div>{viewers.map((viewer: any) => (
        <div
          className={styles.viewer}
          key={viewer.path}
          onClick={() => history.push(`/projects/${store.project.path}/${viewer.path}`)}
        >
          <div className={styles.titleText}>{viewer.title}</div>
          <div className={styles.viewerIcon} data-tooltip={`This app is ${viewer.public ? 'public' : 'private'}`}>
              <FontAwesomeIcon
                icon={viewer.public ? faLockOpen : faLock}
              />
            </div>
            <div className={styles.viewerIcon} data-tooltip={`This app is ${viewer.noConfigCache ? 'not using config cache' : 'using cache'}`}>
              <FontAwesomeIcon
                icon={viewer.noConfigCache ? faXmark : faDatabase}
              />
            </div>
          {viewer.user != null && (
            <div style={{ fontSize: '0.9em', opacity: '0.6' }}>
              {viewer.user.name}
            </div>
          )}
          {hasAuth(auth, viewer.user) && (
            <DeleteAppConfigButton
              deleteAppConfig={() => deleteApp(viewer.id)}
              title={viewer.title}
              createdBy={viewer.user.name}
              createdOn={viewer.createdAt}
            />
          )}
        </div>))}
      </div>
    )

  return (
    <div>

      <Helmet>
        <title>{project.title}</title>
        <link
          rel="icon"
          type="image/png"
          href={`/favicon-${project.path}.png`}
          sizes="16x16"
        />
      </Helmet>

      <BackButton to="/" />
      <Header />

      <div className={styles.mainContainer}>

        <div className={styles.main}>
          <div className={styles.content}>
            <div
              className={styles.title}
            >{`Wistor Apps in ${store.project.title}`}</div>
            {/* <div className={styles.title}>Selecteer een viewer</div> */}
            <div className={styles.viewers}>
              {renderedViewers}
              {auth.status === 'authorized' && auth.user.role !== 'viewer' && (
                <div className={styles.viewer} onClick={newClicked}>
                  <div>
                    <img className="inline" src={add} alt="add" style={{ width: '24px' }} />
                    <span
                      style={{ verticalAlign: 'middle', paddingLeft: '12px' }}
                    >
                      Create a new app...
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  )
}

const emailsWithAnyDeletionRights = [
  'keon.chen@bim-connected.com',
  'marcin.koziuk@bim-connected.com',
  'norent.khy@bim-connected.com',
  'robin.vantol@bim-connected.com',
].map(s => s.toLowerCase())

function hasAuth(auth: WistorAuth, appCreator:  null | {id: string}) {
  if (auth.status !== 'authorized') return false
  if (auth.user.role !== 'superadmin') return false
  if (emailsWithAnyDeletionRights.includes(auth.user.email.toLowerCase())) return true
  if (appCreator && auth.user.id === appCreator.id) return true
  return false
}

function makeID() {
  var text = ''
  var possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  return text
}
